module.exports = __webpack_public_path__ + "img/1.341bf014.png";